import React ,{ReactNode,FC}from 'react'

interface ListSubTitleProps {
    children: ReactNode
}

export const ListSubTitle:FC<ListSubTitleProps> = ({children}) => {
  return (
      <h6 className='m-0 fw-normal' style={{color:'#809FB8',fontSize:'13px'}} >{children}</h6>
  )
}
